import React, { FC } from 'react'

import { BlogCard } from './BlogCard'
import { ChallengeCard } from './ChallengeCard'
import { MerchCard } from './MerchCard'
import { RaceCard } from './RaceCard'
import { MyStatsCard } from './MyStatsCard'
import { TrackerCard } from './TrackerCard'
import { FaqCard } from './FaqCard'
import { FeaturedWideCard } from './FeaturedWideCard'
import { LearnMoreRaceCard } from './LearnMoreRaceCard'
import { LearnMoreChallengeCard } from './LearnMoreChallengeCard'
import { LearnMoreExerciseCard } from './LearnMoreExerciseCard'

export type BaseCardProps = {
    imageURL: string
    href?: string
    onClick?: () => void
    badgeType?: 'free' | 'membersOnly' | 'premium' | 'none'
    percentOff?: number
    premiumText?: {
        prevPrice: number
        newPrice: number
    }
    startDate?: string
    completedDate?: string
    subtitle?: string
}

export interface RaceCardProps extends BaseCardProps {
    cardType: 'race'
    title: string
    distance?: string
    progress?: number | undefined
}

export interface MyStatsCardProps extends BaseCardProps {
    cardType: 'myStats' | 'myStatsCondensed'
    title?: string
    element?: any
    distance?: string
    progress?: number | undefined
    item: any
    condensed: boolean
}

type Trainer = {
    name: string
    intensity?: 1 | 2 | 3
}

export interface ChallengeCardProps extends BaseCardProps {
    cardType: 'challenge'
    title: string
    duration: string
    trainers?: Trainer[]
    intensity?: 1 | 2 | 3
    excerciseType?: string
    progress?: number | undefined
}

type Category = {
    name: string
    color: string
    href: string
}

type Author = {
    imageURL: string
}

export interface BlogCardProps extends BaseCardProps {
    cardType: 'blog'
    publishedDate: string | Date
    category: Category
    author?: Author
    title: string
    previewText: string
    sanitySrc?: any
}

export interface MerchCardProps extends BaseCardProps {
    cardType: 'merch'
    title: string
    price: string
    rating?: number
    featured?: boolean
    isFavorited?: boolean
    selected?: boolean
    isSoldOut?: boolean
}

interface PodcastCardProps extends BaseCardProps {
    cardType: 'podcast'
    publishedDate: string | Date
    title: string
    previewText: string
}

export interface TrackerCardProps extends BaseCardProps {
    cardType: 'tracker'
    title: string
}

export interface FaqCardProps extends BaseCardProps {
    cardType: 'faq'
    title: string
    cardURL: string
}

export interface FeaturedWideCardProps extends BaseCardProps {
    cardType: 'featuredWide'
    title: string
    subTitle: string
    cardURL: string
    bgImage: string
}

export interface LearnMoreRaceCardProps extends BaseCardProps {
    cardType: 'learnMoreRace'
    title: string
    subTitle: string
    featured?: boolean
    tag?: string
}

export interface LearnMoreChallengeCardProps extends BaseCardProps {
    cardType: 'learnMoreChallenge'
    title: string
    subTitle: string
    featured?: boolean
}

export interface LearnMoreExerciseCardProps extends BaseCardProps {
    cardType: 'learnMoreExercise'
    title: string
    subTitle: string
    featured?: boolean
}

export type CardProps =
    | RaceCardProps
    | MyStatsCardProps
    | ChallengeCardProps
    | BlogCardProps
    | MerchCardProps
    | PodcastCardProps
    | TrackerCardProps
    | FaqCardProps
    | LearnMoreRaceCardProps
    | FeaturedWideCardProps
    | LearnMoreChallengeCardProps
    | LearnMoreExerciseCardProps

export const Card: FC<CardProps> = (props) => {
    if (props.cardType === 'race') {
        return <RaceCard {...props} />
    }

    if (props.cardType === 'myStats') {
        return <MyStatsCard {...props} />
    }

    if (props.cardType === 'myStatsCondensed') {
        return <MyStatsCard {...props} />
    }

    if (props.cardType === 'challenge') {
        return <ChallengeCard {...props} />
    }

    if (props.cardType === 'merch') {
        return <MerchCard {...props} />
    }

    if (props.cardType === 'tracker') {
        return <TrackerCard {...props} />
    }

    if (props.cardType === 'featuredWide') {
        return <FeaturedWideCard {...props} />
    }

    if (props.cardType === 'learnMoreRace') {
        return <LearnMoreRaceCard {...props} />
    }

    if (props.cardType === 'learnMoreChallenge') {
        return <LearnMoreChallengeCard {...props} />
    }

    if (props.cardType === 'learnMoreExercise') {
        return <LearnMoreExerciseCard {...props} />
    }

    if (props.cardType === 'faq') {
        return <FaqCard {...props} />
    }

    if (props.cardType === 'blog') {
        return <BlogCard {...props} />
    }

    return null
}
